export const Title = ({ index, content }) => {
    return (
      <p className="uppercase text-green-600 font-semibold mb-6">
        PHẦN {index}. {content}
      </p>
    );
  };
  